import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_EMPLOYER_DASHBOARD } from "./actionTypes"
import {
  getEmployerDashboardSuccess,
  getEmployerDashboardFail

} from "./actions"
import { changePreloader } from "../../../store/actions"

//Include Both Helper File with needed methods
import { getEmployerDashboard } from "../../../helpers/apibackend_helper"

function* fetchDashboards() {
  try {
    const response = yield call(getEmployerDashboard)
    yield put(getEmployerDashboardSuccess(response.data))
  } catch (error) {
    yield put(getEmployerDashboardFail(error))
  } finally {
    yield put(changePreloader(false));
  }
}



function* Dashboardsaga() {
  yield takeEvery(GET_EMPLOYER_DASHBOARD, fetchDashboards)
}

export default Dashboardsaga
